import {useState} from "react"
import {Steps, Select, Button, Card, Spin} from "antd"
import {GlobalOutlined, BarChartOutlined, MessageOutlined} from "@ant-design/icons"
import Constants from "../../../../const/Constants";
import * as API_USER from "../../../../shared/http/user";
import WordListUtils from "../../../utils/WordListUtils";
import {goToExercisePage} from "../../../utils/goToPage";
import {NavigationPages} from "../../../../common/navigation/navigation-pages";
import {useNavigate} from "react-router-dom";
import {setUserRoutine} from "../../../../store/global";
import {useAppDispatch} from "../../../../store/hooks";

const {Option} = Select

function NewComersSections() {
    const [current, setCurrent] = useState(0)
    const [language, setLanguage] = useState(null)
    const [level, setLevel] = useState(null)
    const [loading, setLoading] = useState(false)
    const [loadingStep, setLoadingStep] = useState(0)

    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const reloadPage = () => {
        window.location.reload()
    }

    const STEP_MESSAGES = [
        "🌍 Выберите язык, который хотите изучать",
        "Подпишитесь на нашу группу в Telegram, чтобы быть в курсе новостей и обновлений!",
        "📈 Выберите свой уровень, чтобы мы подготовили подходящий набор",
    ]

    const LOADING_MESSAGES = [
        "📚 Формируем ваш первый список слов...",
        "✨ Настраиваем карточки для обучения...",
        "🚀 Почти готово! Сейчас начнём!",
    ]

    const next = () => setCurrent((prev) => prev + 1)
    const prev = () => setCurrent((prev) => prev - 1)


    const subscribeNext = () => {
        window.open('https://t.me/geekenglishru', '_blank')
        next();
    }

    const startLearning = async () => {
        setLoading(true)
        setLoadingStep(0)
        const interval = setInterval(() => {
            setLoadingStep((prev) =>
                prev < LOADING_MESSAGES.length - 1 ? prev + 1 : prev
            )
        }, 2000)
        try {
            const resp = await API_USER.startLearn(language || '', level || '');
            const user = resp.user;
            if (resp.wordsList) {
                const wordList = WordListUtils.parseNewWordList(resp.wordsList);
                dispatch(setUserRoutine(user))
                goToExercisePage(NavigationPages.CARDS, navigate, wordList)
            } else {
                reloadPage()
            }
        } catch (err) {
            reloadPage()
        } finally {
            clearInterval(interval)
            setLoading(false)
        }
    }

    const steps: { title?: string; icon: any; content: any }[] = [
        {
            icon: <GlobalOutlined/>,
            content: (
                <Select
                    placeholder="Выберите язык"
                    style={{width: "100%"}}
                    onChange={(val) => setLanguage(val)}
                    value={language}
                >
                    {Constants.LANGUAGES.filter(l => l.id !== 'RUSSIAN').map((index, n) => (
                        <Option value={index.id}>{index.id}</Option>
                    ))}
                </Select>
            ),
        },
        {
            icon: <MessageOutlined />,
            content: (
                <>
                    <Button
                        color="purple" variant="outlined"  size="large"
                        block
                        onClick={subscribeNext}
                    >
                        Подписаться
                    </Button>
                </>
            ),
        },
        {
            icon: <BarChartOutlined/>,
            content: (
                <>
                    <Select
                        placeholder="Выберите уровень"
                        style={{width: "100%", marginBottom: 16}}
                        onChange={(val) => setLevel(val)}
                        value={level}
                    >
                        {Constants.CEFR_LEVELS_OBJECTS.map((index, n) => (
                            <Option value={index.value}>{index.label}</Option>
                        ))}
                    </Select>

                    <Button
                        type="primary"
                        size="large"
                        block
                        disabled={!level}
                        onClick={startLearning}
                    >
                        🚀 Поехали!
                    </Button>
                </>
            ),
        },
    ]

    return (
        <>
            {loading && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "rgba(255, 255, 255, 0.9)",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999,
                    }}
                >
                    <Spin size="large"/>
                    <p style={{marginTop: 16, fontSize: 18, textAlign: "center"}}>
                        {LOADING_MESSAGES[loadingStep]}
                    </p>
                </div>
            )}
            <section className="block-content t-block-teal l-block-spacing">
                <div className="l-contained">
                    <Card
                        style={{maxWidth: 500, margin: "0 auto"}}
                        bordered={false}
                    >
                        <header style={{textAlign: "center", marginBottom: "1.5rem"}}>
                            <h2>🎉 Добро пожаловать!</h2>
                            <p className="subtitle">{STEP_MESSAGES[current]}</p>
                        </header>

                        <Steps
                            current={current}
                            items={steps.map((s) => ({
                                title: s.title,
                                icon: s.icon,
                            }))}
                            direction="horizontal"
                            style={{marginBottom: "1.5rem"}}
                        />

                        <div style={{marginBottom: 24}}>{steps[current].content}</div>

                        <div style={{display: "flex", justifyContent: "space-between"}}>
                            {current > 0 && (
                                <Button onClick={prev} style={{marginRight: 8}}>
                                    Назад
                                </Button>
                            )}

                            {current < steps.length - 1 && (
                                <Button
                                    type="primary"
                                    onClick={next}
                                    disabled={!language}
                                >
                                    {current === 1 ? "Пропустить" : "Далее"}
                                </Button>
                            )}
                        </div>
                    </Card>
                </div>
            </section>
        </>

    )
}

export default NewComersSections
